<template>
  <li>
    <router-link :to="`/school_design_detail?id=${itemObj.id}`" target="_blank">
      <!-- 图片 -->
      <!-- <div class="img_box"></div> -->
      <div class="image">
        <img v-lazy="itemObj.coverPath" alt="">
      </div>
      <!-- 内容 -->
      <div class="masterList_inner_box">
        <h3 class="inner_title">{{ itemObj.name }}</h3>
        <div class="inner_desc">
          <div class="inner_desc_money" v-if="itemObj.money">￥{{ itemObj.money }}</div>
          <div class="inner_desc_money" v-else>免费</div>
          <div class="inner_desc_enroll">
            <i class="my_icon user"></i> {{ itemObj.apply_count }}人已报名
          </div>
        </div>
      </div>
    </router-link>
  </li>
</template>

<script>
export default {
  props:{
    itemObj:{
      type:Object
    }
  }
};
</script>

<style lang="scss" scoped>
li:nth-child(4n) {
  margin-right: 0;
}
li {
  background-color: #fff;
  border: 1px solid $bd-color;
  margin: 0 20px 20px 0;
  box-sizing: border-box;
  cursor: pointer;
  width: 285px;
  height: 295px;
  transition: all 0.3s;
  list-style: none;
  .image {
    overflow: hidden;
    img {
      height: 212px;
      width: 100%;
      transition: all 0.3s;
      object-fit: cover;
    }
  }
  .masterList_inner_box {
    padding: 10px 20px;
    .inner_title {
      line-height: 32px;
      font-size: 16px;
      color: rgba(51, 51, 51, 1);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      word-wrap: normal;
    }
    .inner_desc {
      display: flex;
      justify-content: space-between;
      line-height: 25px;
      .inner_desc_money {
        font-size: 14px;
        color: rgba(212, 40, 45, 1);
      }
      .inner_desc_enroll {
        font-size: 12px;
        color: rgba(170, 170, 170, 1);
      }
    }
  }
}
li:hover {
  box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.1);
  .image img {
    transform: scale(1.1);
  }
}
</style>
